<template>
    <div v-if="!confirmOk" class="reset-password">
        <div class="modal-title">Регистрация по номеру телефона</div>
        <div v-if="!step2">
            <form class="modal-form">
                <p class="forgot-password-client__text">
                    Вход по номеру клиента скоро будет отключен.<br>
                    Пожалуйста, зарегистрируйтесь по номеру телефона.
                </p>
                <input-text
                    label       = "Номер телефона"
                    required    = "*"
                    :errorText  = "phoneError"
                    placeholder = "+7 (___) ___-__-__"
                    maskVal     = "phone"
                    name        = "phone"
                    ref         = "phoneInput"
                    @onComplete = "getPhoneValue"
                    @onAccept   = "onPhoneAccept"
                />
                <div class="modal-button flex">
                    <orange-button
                        text            = "Зарегистрировать"
                        @click.prevent  = "confirmPhone"
                        ref             = "submitButton"
                    />
                </div>
            </form>
        </div>
        <div v-else-if="step2">
            <a
                href="#"
                class="backward-button"
                @click.prevent="step2 = false"
            >
                <i>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 6.8C11.4418 6.8 11.8 6.44183 11.8 6C11.8 5.55817 11.4418 5.2 11 5.2V6.8ZM0.434315 5.43431C0.121895 5.74673 0.121895 6.25327 0.434315 6.56569L5.52548 11.6569C5.8379 11.9693 6.34443 11.9693 6.65685 11.6569C6.96927 11.3444 6.96927 10.8379 6.65685 10.5255L2.13137 6L6.65685 1.47452C6.96927 1.1621 6.96927 0.655565 6.65685 0.343146C6.34443 0.0307264 5.8379 0.0307264 5.52548 0.343146L0.434315 5.43431ZM11 5.2L1 5.2V6.8L11 6.8V5.2Z"></path>
                    </svg>
                </i>
                Назад
            </a>
            <form class="modal-form">
                <input-text
                    label       = "Код подтверждения"
                    required    = "*"
                    :errorText  = "codeError"
                    placeholder = "Код подтверждения"
                    name        = "phone-verification-code"
                    ref         = "codeInput"
                    @onComplete = "getCodeValue"
                />
                <input-password
                    label       = "Новый пароль"
                    required    = "*"
                    :errorText  = "passwordError"
                    placeholder = "Новый пароль"
                    name        = "new-password"
                    ref         = "newPasswordInput"
                    @onComplete = "getPasswordValue"
                />
                <input-password
                    label       = "Подтвердите пароль"
                    required    = "*"
                    :errorText  = "passwordError"
                    placeholder = "Подтвердите пароль"
                    name        = "confirm-password"
                    ref         = "confirmPasswordInput"
                    @onComplete = "getRePasswordValue"
                />
                <p class="input-error" v-if="generalError">{{generalError}}</p>
                <input type="hidden" name="phone" :value="phone" />
                <div class="modal-button flex">
                    <orange-button
                        text            = "Сохранить"
                        @click.prevent  = "completeRegistration"
                        ref             = "submitButton"
                    />
                </div>
            </form>
        </div>
    </div>
    <div v-else class="modal-win__wrap">
        <div class="modal-win__inner">
            <img src="/assets/images/success.svg" alt="">
            <p>Пароль успешно изменён.<br>Войдите в личный кабинет по номеру телефона.</p>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import InputText from '@/components/UI/InputText'
import InputPassword from '@/components/UI/InputPassword'
import OrangeButton from '@/components/UI/OrangeButton'

export default {
    name: 'modal-phone-registration',
    emits: ['onClose'],
    components: {
        InputText,
        InputPassword,
        OrangeButton,
    },
    data() {
        return {
            phone: '',
            phoneMaskValue: '',
            verificationCode: '',
            password: '',
            repassword: '',
            phoneError: '',
            codeError: '',
            passwordError: '',
            generalError: '',
            step2: false,
            confirmOk: false,
            inputDisabled: false,
            apiUrl: this.$store.state.apiUrl,
            token: this.$store.state.token,
        }
    },
    computed: {
        clientNumber() {
            return this.$store.state.currentAccount?.client_number || ''
        }
    },
    methods: {
        onPhoneAccept(e) {
            this.phone = e.value
        },
        getPhoneValue(e) {
            this.phone = e.value
            this.phoneMaskValue = e.maskValue
        },
        getCodeValue(e) {
            this.verificationCode = e.value
        },
        getPasswordValue(e) {
            this.password = e.value
        },
        getRePasswordValue(e) {
            this.repassword = e.value
        },
        setInputDisabled(status) {
            if (this.$refs.submitButton)
                this.$refs.submitButton.setDisabled(status)
        },
        async confirmPhone() {
            if (!this.phone) {
                this.phoneError = 'Введите номер телефона'
                return
            }

            this.setInputDisabled(true)
            this.phoneError = ''

            try {
                await axios.post(
                    this.apiUrl + '/api/user/confirmPhone',
                    { phone: this.phone, client_number: this.clientNumber },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )
                this.step2 = true
                this.setInputDisabled(false)
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors && e.response.data.errors.phone) {
                    this.phoneError = e.response.data.errors.phone[0]
                } else if (e.response && e.response.data && e.response.data.message) {
                    this.phoneError = e.response.data.message
                } else {
                    this.phoneError = 'Произошла ошибка'
                }
                this.setInputDisabled(false)
            }
        },
        async completeRegistration() {
            this.passwordError = ''
            this.codeError = ''
            this.generalError = ''

            if (!this.verificationCode) {
                this.codeError = 'Введите код подтверждения'
                return
            }
            if (!this.password) {
                this.passwordError = 'Введите пароль'
                return
            }
            if (!this.repassword) {
                this.passwordError = 'Подтвердите пароль'
                return
            }
            if (this.password !== this.repassword) {
                this.passwordError = 'Пароли не совпадают'
                return
            }

            this.setInputDisabled(true)

            try {
                await axios.post(
                    this.apiUrl + '/api/user/passwordOld',
                    {
                        phone: this.phone,
                        client_number: this.clientNumber,
                        verification_code: this.verificationCode,
                        password: this.password,
                        confirmed_password: this.repassword,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )

                this.confirmOk = true
                this.step2 = false
                this.setInputDisabled(false)
            } catch (e) {
                if (e.response && e.response.data && e.response.data.errors) {
                    const errors = e.response.data.errors
                    if (errors.password) {
                        this.passwordError = errors.password[0]
                    }
                    if (errors.verification_code) {
                        this.codeError = errors.verification_code[0]
                    }
                }
                if (e.response && e.response.data && e.response.data.message) {
                    this.generalError = e.response.data.message
                }
                this.setInputDisabled(false)
            }
        },
    }
}
</script>
